import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import OldUIContext from "../../olduicontext"
import { getWorkspaceId } from "../../util/GetWorkspaceId"
import { timeDependingGreeting } from "../../util/GreetingGenerator"
import { AppStore } from "../../store"

import { initializeSearch } from "../search/actions"

import * as actions from "./actions"

import WelcomePage from "./components/WelcomePage"
import { Labels } from "../../util/Translations"
import { ISmartSearchInitData } from "../search"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        userName: string,
        smartSearchInitData: ISmartSearchInitData,
    ) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        userName: string,
        smartSearchInitData: ISmartSearchInitData,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        const hour = new Date().getHours()
        const { NoWorkspacesFoundFiltered, NoWorkspacesFound } = Labels
        store.dispatch(
            actions.initialize(
                timeDependingGreeting(hour),
                userName,
                NoWorkspacesFound,
                NoWorkspacesFoundFiltered,
            ),
        )
        store.dispatch(initializeSearch(getWorkspaceId(), smartSearchInitData))

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <WelcomePage isSmartSearch={!!smartSearchInitData} />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        start,
    }
}

export default init
